import { Toaster } from "react-hot-toast";
//import react router dom
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import Menu from "./components/nav/Menu";
import Footer from "./components/nav/Footer";
import PrivateRoute from "./components/routes/PrivateRoute";
import AdminRoute from "./components/routes/AdminRoute";
import GlobalLoader from "./components/loader/GlobalLoader";

// Public pages
const Home = lazy(() => import("./pages/Home"));
const Contact = lazy(() => import("./pages/Contact"));
const Login = lazy(() => import("./pages/auth/Login"));
const LoginPhone = lazy(() => import("./pages/auth/LoginPhone"));
const Register = lazy(() => import("./pages/auth/Register"));
const Shop = lazy(() => import("./pages/Shop"));
const Search = lazy(() => import("./pages/Search"));
const ProductView = lazy(() => import("./pages/ProductView"));
const Cart = lazy(() => import("./pages/Cart"));
const CategoriesList = lazy(() => import("./pages/CategoriesList"));
const RBV = lazy(() => import("./pages/RBV"));
const CategoryView = lazy(() => import("./pages/CategoryView"));
const PageNotFound = lazy(() => import("./pages/PageNotFound"));

// User pages
const Dashboard = lazy(() => import("./pages/user/Dashboard"));
const UserProfile = lazy(() => import("./pages/user/Profile"));
const UserOrders = lazy(() => import("./pages/user/Orders"));
const UserCart = lazy(() => import("./pages/user/UserCart"));
const Receipt = lazy(() => import("./pages/user/Receipt"));
const UserWishlist = lazy(() => import("./pages/user/Wishlist"));
const UserInfoMenu = lazy(() => import("./components/nav/UserInfoMenu"));

// Admin pages
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));
const AdminCategory = lazy(() => import("./pages/admin/Category"));
const AdminCategories = lazy(() => import("./pages/admin/Categories"));
const AdminProduct = lazy(() => import("./pages/admin/Product"));
const AdminProducts = lazy(() => import("./pages/admin/Products"));
const ManageOrders = lazy(() => import("./pages/admin/ManageOrders"));
const AdminProductUpdate = lazy(() => import("./pages/admin/ProductUpdate"));
const AllUsers = lazy(() => import("./pages/admin/AllUsers"));
const AllAdmin = lazy(() => import("./pages/admin/AdminAll"));
const AdminInfoMenu = lazy(() => import("./components/nav/AdminInfoMenu"));


export default function App() {
  // const GlobalLoader = () => (
  //   <div style={{ textAlign: "center", padding: "40px" }}>Loading...</div>
  // );

  //const GlobalLoader = () => <GlobalGlobalLoader />;

  return (
    <BrowserRouter>
      <Menu />
      <Toaster />

      <Routes>
        {/* ================= PUBLIC ROUTES ================= */}
        <Route
          path="/"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Home />
            </Suspense>
          }
        />

        <Route
          path="/shop"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Shop />
            </Suspense>
          }
        />
        <Route
          path="/search"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Search />
            </Suspense>
          }
        />
        <Route
          path="/product/:slug"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <ProductView />
            </Suspense>
          }
        />
        <Route
          path="/cart"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Cart />
            </Suspense>
          }
        />
        <Route
          path="/categories"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <CategoriesList />
            </Suspense>
          }
        />
        <Route
          path="/products-by-category/:slug"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <CategoryView />
            </Suspense>
          }
        />
        <Route
          path="/rbv"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <RBV />
            </Suspense>
          }
        />
        <Route
          path="/login"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="/login/phone"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <LoginPhone />
            </Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Register />
            </Suspense>
          }
        />
        <Route
          path="/contact"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <Contact />
            </Suspense>
          }
        />

        {/* ================= USER ROUTES ================= */}
        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route
            path="user/"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <Dashboard />
              </Suspense>
            }
          >
            <Route index element={<UserInfoMenu />} />

            <Route
              path="profile"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <UserProfile />
                </Suspense>
              }
            />

            <Route
              path="orders"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <UserOrders />
                </Suspense>
              }
            />

            <Route
              path="order/:id"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <Receipt />
                </Suspense>
              }
            />

            <Route
              path="cart"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <UserCart />
                </Suspense>
              }
            />

            <Route
              path="wishlist"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <UserWishlist />
                </Suspense>
              }
            />
          </Route>
        </Route>






        {/* ================= Admin ROUTES ================= */}
        <Route path="/dashboard" element={<AdminRoute />}>
          <Route
            path="admin/"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminDashboard />
              </Suspense>
            }
          >
            <Route index element={<AdminInfoMenu />} />

            <Route
              path="category"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AdminCategory />
                </Suspense>
              }
            />
            <Route
              path="categories"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AdminCategories />
                </Suspense>
              }
            />
            <Route
              path="product"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AdminProduct />
                </Suspense>
              }
            />
            <Route
              path="products"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AdminProducts />
                </Suspense>
              }
            />
            <Route
              path="manage-orders"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <ManageOrders />
                </Suspense>
              }
            />
            <Route
              path="product/update/:slug"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AdminProductUpdate />
                </Suspense>
              }
            />
            <Route
              path="all-admin"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AllAdmin />
                </Suspense>
              }
            />
            <Route
              path="update-admin"
              element={
                <Suspense fallback={<GlobalLoader />}>
                  <AllUsers />
                </Suspense>
              }
            />
          </Route>
        </Route>

        {/* ================= ADMIN ROUTES ================= */}
        {/* <Route path="/dashboard" element={<AdminRoute />}>
          <Route
            path="admin"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminDashboard />
              </Suspense>
            }
          />
          <Route
            path="admin/category"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminCategory />
              </Suspense>
            }
          />
          <Route
            path="admin/categories"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminCategories />
              </Suspense>
            }
          />
          <Route
            path="admin/product"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminProduct />
              </Suspense>
            }
          />
          <Route
            path="admin/products"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminProducts />
              </Suspense>
            }
          />
          <Route
            path="admin/manage-orders"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <ManageOrders />
              </Suspense>
            }
          />
          <Route
            path="admin/product/update/:slug"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AdminProductUpdate />
              </Suspense>
            }
          />
          <Route
            path="admin/all-admin"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AllAdmin />
              </Suspense>
            }
          />
          <Route
            path="admin/update-admin"
            element={
              <Suspense fallback={<GlobalLoader />}>
                <AllUsers />
              </Suspense>
            }
          />
        </Route> */}

        {/* ================= 404 ================= */}
        <Route
          path="*"
          element={
            <Suspense fallback={<GlobalLoader />}>
              <PageNotFound />
            </Suspense>
          }
        />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

// export default App;
